import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";
import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'

class CheckerBox extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {}

        this.initState = this.initState.bind(this)
        this.initControl = this.initControl.bind(this)
        this.handlerOnClicked=this.handlerOnClicked.bind(this)
   
        this.initState()
    }

    initState() {
        let { doctype,checked } = this.props

        this.state = {
            checked:checked,
            visible: true,
            disabled: (!doctype || doctype == "") ? this.props.disabled : false,
            description: null,
            tagLabel: null,
            error: false,
            error_message: null
        }
    }

    initControl() {
        let { doctype, tagid } = this.props

        if (!doctype || !tagid) return

        var tagInfo = tagsConfigHelper.findTagConfig(tagid, doctype)

        if (tagInfo) {
            this.setState({
                visible: tagInfo.visibled,
                disabled: !tagInfo.enabled,
                description: tagInfo.tagDescription,
                tagLabel: tagInfo.tagLabel
            })

            ControlManager.setLabel(tagInfo.tagLabel, tagInfo.visibled, tagInfo.required)
            ControlManager.setSubLabel(tagInfo.tagSubLabel, tagInfo.visibled)
        }
    }

    handlerOnClicked(name, event) {
        // console.log("handlerOnClicked:")
        this.setState({checked: event.target.checked})
        // console.log(name);
        // console.log(event.target)
        // console.log(event.target.checked);

        if(this.props.onChange){
            this.props.onChange(event)
        }
        
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.doctype !== nextProps.doctype) {
            this.initControl()
        }

        if (this.state.checked !== nextProps.checked) {
            // console.log("componentWillReceiveProps(nextProps.checked): ", nextProps.checked)
            this.setState({checked:nextProps.checked===true || nextProps.checked==="1"})
        }

        //กรณีไม่ได้กำหนด DocType บางค่าให้เชื่อตามที่กำหนดจากข้างนอก
        if(!nextProps.doctype || nextProps.doctype===""){
            if (this.state.disabled !== nextProps.disabled) {
                this.setState({disabled:nextProps.disabled})
            }
        }
    }

    componentDidMount() {
        this.initControl()
    }

    render() {
        let { disabled, visible, checked } = this.state
        const {id, name,text } = this.props

        if (this.props.doctype) {
            var tagInfo = tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {
                disabled = !tagInfo.enabled
                visible = tagInfo.visibled
            }
        }

        return (
            visible===true? <FormControlLabel style={this.props.style}
                control={
                    <Checkbox
                        id={id}
                        name={name}
                        //className={[this.props.viewMode?"form-control.form-control-gray":"","", this.props.className].join(' ').replace(!this.props.viewMode?"form-control.form-control-gray":"","" )}
                        checked={checked===true || checked===1 || checked==="1" }
                        defaultValue={name}
                        color="primary"
                        onClick={ (event) => { this.handlerOnClicked(name, event )}}
                        //disabled={disabled} 
                        disabled={disabled||this.props.viewMode?"disabled":null}
                    />
                }
                label={text}
            />: null
        )
    }
}

CheckerBox.defaultProps = {
    type: "text"
}

CheckerBox.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
}

export default CheckerBox